import React, { Component } from 'react';

class EasyTable extends Component {

	render() {
		const { tableName, data, headers } = this.props;

		return (
			<div className={"EasyTable"}>
				<div>
					<h3>{tableName}</h3>
				</div>

				<table>
					<thead>
						{this.makeColumnHeaders(headers)}
					</thead>
					<tbody>
						{this.makeRows(data)}
					</tbody>
				</table>

				<div>
					{this.props.children}
				</div>
			</div>
		);
	}

	makeColumnHeaders = (headers) => {
		return (
			<tr>
				{headers.map((h, index) => {
					return <th key={index}>{h}</th>
				})}
			</tr>
		)
	};

	makeRows = (data) => {
		const p = this.props;
		{
			return data.map((row, index) => {
				return (
					<tr onClick={() => p.onClick(row[p.selectValue])} key={index}>
						{this.makeColumns(row)}
					</tr>
				)

			})
		}

	};

	makeColumns = (row) => {
		const p = this.props;
		return p.show.map((property, index) => {
			if (p.customColumns !== undefined && p.customColumns.includes(property)) {
				return p.renderCustomColumn(property, row, index)
			} else {
				return <td key={index}>{row[property]}</td>;
			}
		});
	};

}

export default EasyTable;


// WEBPACK FOOTER //
// ./src/components/projectmanager/EasyTable.js